var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHideEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63281 1.2477C1.47572 1.08532 1.21673 1.08102 1.05434 1.23811C0.891957 1.3952 0.887662 1.65419 1.04475 1.81657L4.44927 5.33591C2.35015 7.01915 1.54457 9.44738 1.52306 9.51288L1.52269 9.51363C1.44394 9.76113 1.57894 10.0236 1.82644 10.1024C2.07394 10.1811 2.33644 10.0461 2.41519 9.79863C2.45986 9.65967 3.18601 7.46639 5.09025 5.99851L6.69605 7.65845C6.66807 7.68458 6.64049 7.71124 6.61333 7.7384C5.98039 8.37133 5.62481 9.22978 5.62481 10.1249C5.62481 11.02 5.98039 11.8784 6.61333 12.5114C7.24626 13.1443 8.10471 13.4999 8.99981 13.4999C9.89492 13.4999 10.7534 13.1443 11.3863 12.5114C11.387 12.5106 11.3878 12.5099 11.3885 12.5092L14.6976 15.9299C14.8547 16.0923 15.1137 16.0966 15.2761 15.9395C15.4385 15.7824 15.4428 15.5234 15.2857 15.361L11.8963 11.8573C11.8963 11.8573 11.8963 11.8573 11.8963 11.8573L7.36442 7.17257C7.36441 7.17257 7.36443 7.17256 7.36442 7.17257L5.77931 5.53405C5.77931 5.53405 5.77932 5.53404 5.77931 5.53405L5.12172 4.85423C5.12171 4.85424 5.12173 4.85423 5.12172 4.85423L1.63281 1.2477Z",
    fill: "#04D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86226 4.44299L6.54983 5.15374C7.25607 4.86487 8.06892 4.68738 9.00019 4.68738C13.8939 4.68738 15.5173 9.58863 15.5848 9.79863C15.6228 9.91688 15.706 10.0153 15.8164 10.0722C15.9268 10.1291 16.0552 10.14 16.1736 10.1024C16.4173 10.0236 16.5561 9.76113 16.4773 9.51363L16.4768 9.51202C16.4379 9.39542 14.5568 3.74988 8.99944 3.74988C7.78435 3.74988 6.74501 4.01987 5.86226 4.44299Z",
    fill: "#04D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2474 11.0435L8.18941 6.84861C8.4524 6.78355 8.72437 6.74988 8.99981 6.74988C9.89492 6.74988 10.7534 7.10546 11.3863 7.7384C12.0192 8.37133 12.3748 9.22978 12.3748 10.1249C12.3748 10.4383 12.3312 10.7472 12.2474 11.0435Z",
    fill: "#04D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/hide_eye.358ea5bfe54ea3c72f1f75184ea968f6.svg";
export { ForwardRef as ReactComponent };